(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customization-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.custom-tabs button');
  const panes = document.querySelectorAll('.tab-pane');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      panes.forEach(p => p.classList.remove('show'));

      this.classList.add('active');
      const target = document.querySelector(this.dataset.target);
      if (target) target.classList.add('show');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
